export const hasSearchParams = (values: any, keyChecks: string[]) => {
  const hasSearchValues = keyChecks.some(
    (key) => values[key] && Object.keys(values[key]).length !== 0 && values[key] !== "false",
  );
  return hasSearchValues;
};
